module.exports = __webpack_public_path__ + "img/23.12b878fc.jpg";